import React from 'react';
import classNames from 'classnames';
import { Avatar, AvatarSize } from 'wix-ui-tpa';
import { parseToRGB } from '../../../common/services/parse-color';
import { getPresetColor } from './get-preset-color';
import styles from './anonymous-avatar.scss';
const getDiameter = (size) => {
    switch (size) {
        case AvatarSize.medium:
            return 36;
        case AvatarSize.xSmall:
            return 20;
        default:
            return 28;
    }
};
export const AnonymousAvatar = ({ className, size = AvatarSize.medium, hexColor: hexColor2, withBorder = false, screenshotMode = false, }) => {
    const hexColor = screenshotMode ? getPresetColor(hexColor2) : hexColor2;
    const diameter = getDiameter(size);
    const hueDegree = React.useMemo(() => {
        const color = parseToRGB(hexColor);
        if (color) {
            return Math.floor(((color.r + color.g + color.b) / (765 / 360)) * 5);
        }
        else {
            return 0;
        }
    }, [hexColor]);
    return (React.createElement("div", { className: classNames(styles.anonymousAvatar, className, 'wc-bg-text-color', {
            [styles.withBorder]: withBorder,
        }), style: {
            width: diameter,
            height: diameter,
        } },
        React.createElement("div", { className: styles.filter, style: {
                filter: `sepia(0.3) contrast(0.8) saturate(3) hue-rotate(${hueDegree}deg)`,
                color: hexColor,
            } },
            React.createElement(Avatar, { size: size }))));
};
//# sourceMappingURL=anonymous-avatar.js.map